import { useRoute } from "@react-navigation/native";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ORDER_FLOW_EVENTS } from "@constants/analyticsEventsCT";
import { actions as cartActions } from "@reducers/cartReducer";
import cleverTapAnalytics from "@services/analytics";
import { setCartItem } from "@services/api";
import toast from "@utils/toast";

const useCartActions = () => {
  const [isCartValueLoading, setIsCartValueLoading] = useState(false);
  const cart = useSelector((state) => state.cart);
  const dispatch = useDispatch();
  const screenName = useRoute().name;

  const addCart = (sku_id, cust_id, cb = () => {}, count, eventPayload) => {
    const apiPayload = {
      userId: cust_id,
      quantity: count || 1,
      skuId: sku_id,
    };

    if (count === 0) {
      apiPayload.quantity = 0;
    }

    setIsCartValueLoading(true);
    setCartItem(apiPayload)
      .then(({ data }) => {
        if (data.error) {
          toast.showLongToast(data.error);
        }
        dispatch(cartActions.viewCartLiteSuccess(data, apiPayload.userId));
        if (data.result) {
          cleverTapAnalytics.trackEvent(ORDER_FLOW_EVENTS.PRODUCT_ADDED, {
            items_in_cart: data.result.length,
            screen_name: screenName,
            ...(!!eventPayload && eventPayload),
          });
        }
        setIsCartValueLoading(false);
        cb(data);
      })
      .catch((e) => {
        cb();
        console.log(e);
        setIsCartValueLoading(false);
        cb();
      });
  };

  const removeCart = (sku_id, user_id, cb = () => {}, count, eventPayload) => {
    const apiPayload = {
      userId: user_id,
      quantity: count ? count : -1,
      skuId: sku_id,
    };
    setIsCartValueLoading(true);
    setCartItem(apiPayload)
      .then(({ data }) => {
        dispatch(cartActions.viewCartLiteSuccess(data, apiPayload.userId));
        if (data.result) {
          cleverTapAnalytics.trackEvent(ORDER_FLOW_EVENTS.PRODUCT_REMOVED, {
            screen_name: screenName,
            items_in_cart: data.result.length,
            ...(!!eventPayload && eventPayload),
          });
        }
        setIsCartValueLoading(false);
        cb();
      })
      .catch((e) => {
        console.log(e);
        setIsCartValueLoading(false);
      });
  };

  const countOfItem = (sku_id) => {
    const { cartItems = [] } = cart;

    const selectedProduct =
      Array.isArray(cartItems) &&
      cartItems.length > 0 &&
      cartItems.find((c) => c.sku_id === sku_id && !c.discounted_product);
    return selectedProduct && selectedProduct.quantity;
  };

  return {
    addCart,
    removeCart,
    countOfItem,
    isCartValueLoading,
  };
};

export default useCartActions;
